import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import Stats from "./Stats";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getCurrentUserRole } from "modules/utilities/utility";
import TicketTab from './TicketTabs';
import TicketingDashboard from 'modules/ticketing_dashboard/TicketingDashboard';
import { useOrderSearchForTicket } from "modules/CreateTicket/store";
import _ from "lodash";
import FailedTicket from 'modules/failed_ticket/FailedTicket';
import { ROLES_NAME } from 'modules/utilities/utility';
import CustomerComplaintTickets from 'modules/customer_complaint_slot/CustomerComplaintTickets';
import { isComplaintTeam } from 'modules/navbar/top/helper';
const { ADMIN, SUPER_ADMIN, CONSULT_DOCTOR, DOCTOR, SUPPORT, IVR, MEDREP_EXT, MEDREP_EXT_SS } = ROLES_NAME;

function Tickets() {
  const { crmCategories, fetchCrmCategories } = useOrderSearchForTicket();
  const [activeTab, setActiveTab] = useState("assigned");
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const userRole = getCurrentUserRole();

  useEffect(() => {
    if(_.isEmpty(crmCategories)){ 
      fetchCrmCategories(); 
    }
    const tab = searchParams.get("tab");
    setActiveTab(tab);
  }, []);

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    navigate(`/myTickets?tab=${tabKey}`);
  };
  return (
    <div>
      <Tabs
        variant="pills"
        defaultActiveKey="assigned"
        id="uncontrolled-tab-example"
        activeKey={activeTab}
        onSelect={handleTabChange}
        className="pb-2 border-bottom border-2 "
      >
        <Tab eventKey="assigned" title="Assigned Tickets" className="mb-3">
          <TicketTab tab={activeTab} />
        </Tab>
        {[ADMIN, SUPER_ADMIN].includes(userRole) && (
          <Tab
            eventKey="internalTickets"
            title="Internal Tickets"
            className="mb-3"
          >
            <TicketTab tab={activeTab} />
          </Tab>
        )}
        {getCurrentUserRole() !== "medrep_ext_ss" && (
          <Tab eventKey="all" title="All Tickets" className="mt-2">
            <TicketTab tab={activeTab} />
          </Tab>
        )}
        {[CONSULT_DOCTOR, DOCTOR, SUPPORT, IVR, MEDREP_EXT, MEDREP_EXT_SS].includes(getCurrentUserRole()) ? null : (
          <Tab eventKey="stats" title="Stats" className="mt-2">
            <Stats tab={activeTab} />
          </Tab>
        )}
        {[SUPER_ADMIN].includes(getCurrentUserRole()) && (
          <Tab eventKey="ticketing-dashboard" title="Ticketing Dashboard" className="mt-2">
            <TicketingDashboard />
          </Tab>
        )}
        {[SUPER_ADMIN].includes(getCurrentUserRole()) && (
          <Tab eventKey="failed-ticket" title="Failed Ticket" className="mt-2">
            <FailedTicket />
          </Tab>
        )}
        {isComplaintTeam() && (
          <Tab eventKey="cx-complaint-slot" title="Customer Complaint Slots" className="mt-2">
            <CustomerComplaintTickets />
          </Tab>
        )}
      </Tabs>
    </div>
  );
}
export default Tickets;
